
















import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { Home } from "@/shared/route-names";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useSsoStore } from "@/employee/store/sso";
import { useUserStore } from "@/shared/store/user";

@Component ({
  components: {
    GenericLoadingSpinner
  }
})
export default class SsoValidateAccount extends Vue {
  ssoStore = useSsoStore();
  userStore = useUserStore();

  @Prop() token: string;

  mounted (): void {

    if (this.userStore.loggedIn && !this.token) {
      this.$router.push({ name: Home });
      return;
    }
    if (this.token) {
      this.ssoStore.validateSsoAccount(this.token);
    } else {
      this.$router.push({name: LoginRouteNames.Login});
    }
  }

@Watch("userStore.loggedIn")
  watchLoggedIn (): void {
    if (this.userStore.loggedIn) {
      this.$router.push({ name: Home });
    }
  }
}
